import Vue from 'vue'
import appConfig from '@/config.js'

const itemPacksModel = vm => ({
  title: vm.$gettext('Item Packs'),
  endpoint: 'item-packs',
  endpointDelete: 'item-packs/{id}/discard',
  allowNew: true,
  allowDelete: true,
  showIncludes: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'reference',
      label: vm.$gettext('Pack Reference'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'reference_code',
      label: vm.$gettext('Reference Code/SKU'),
      sortable: true,
      editable: true
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country'),
      sortable: true
    },
    {
      key: 'created_by_id',
      label: vm.$gettext('Created By'),
      sortable: true,
      formatter: (value, key, item) => {
        return '<a href="/edit/users/' + value + '" target="_blank">#' + value + '</a>'
      }
    },
    {
      key: 'quantity',
      label: vm.$gettext('Items Quantity'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Quantity of items in the pack'),
      formatter: (value, key, item) => {
        return item.serial_numbers ? item.serial_numbers.length + '/' + value : '0/' + value
      },
      editCondition: item => {
        return item.status === 'DRAFT'
      }
    },
    {
      key: 'status',
      sortable: true,
      label: vm.$gettext('Status')
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: true
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    },
    {
      key: 'serial_numbers',
      label: vm.$gettext('Serial Numbers'),
      sortable: false,
      editable: true,
      type: Array
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Pack Label'),
      type: 'button',
      icon: 'file-pdf',
      title: vm.$gettext('Get Pack PDF label'),
      variant: 'dark',
      position: 'start',
      disabledCondition: item => {
        return false
      },
      action: item => {
        const data = {
          url: appConfig.api.baseUrl + 'item-packs/' + item.id + '/label',
          params: null,
          type: 'application/pdf;charset=utf-8;',
          filename: 'pack_' + item.id + '_label'
        }
        Vue.http.get(data.url, { params: data.params, responseType: 'blob' }).then(response => {
          const blob = new Blob([response.body], { type: data.type })
          if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, data.filename)
          } else {
            const link = document.createElement('a')
            if (link.download !== undefined) {
              // feature detection
              // Browsers that support HTML5 download attribute
              const url = URL.createObjectURL(blob)
              link.setAttribute('href', url)
              link.setAttribute('download', data.filename)
              link.style.visibility = 'hidden'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
          }
        })
      }
    }
  ],
  filters: ['id', 'reference', 'created_by_id', 'quantity', 'status'],
  exclude: ['serial_numbers']
})

export default itemPacksModel
